<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{ 'iotemeter.performance_analytics.peak_power' | translate }}
				<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportPeakPower()"
					*ngIf="peakPowerExport.length"></button>
			</h4>
		</div>
	</div>

	<!-- date filter -->
	<div class="row col-xl-7 mb-4">
		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>
	
	<div *ngIf="chartsData.length; else noData">
		<sct-charts
			id="im-peak-power"
			class="chart"
			[data]="chartsData"
			[columnNames]="chartObject.columnNames"
			[options]="chartObject.config"
			[type]="'ColumnChart'"
			[height]="500"
			(select)="onPeakPowerDataClick($event)"
		></sct-charts>
	</div>
</div>

<app-modal [hasConfirmButton]="false" [hasCloseButton]="false" #popupModal [title]="'g.events' | translate">
	<sct-custom-table
		*ngIf="tableData.length"
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</app-modal>

<ng-template #noData>
	{{'g.no_data_available_for_the_selected_period' | translate}}
</ng-template>
